import React from "react"
import Studio from "../Studio"
import WithPages from "data/wrappers/WithPages"
import PageTable from "../components/PageTable"
import PageTitle from "ui/components/PageTitle"
import Breadcrumbs from "ui/components/Breadcrumbs"

// import RecordTable from "features/studio/components/RecordTable"
import NewPageButton from "../components/NewPageButton"
import { Container, Section } from "ui"
import WithApps from "data/wrappers/WithApps"

export default class PageListPage extends React.Component {
    render() {
        return (
            <Studio color="red">
                <Container marginBottom="medium" spaced>
                    <Section margin="none" padding="none">
                        <Breadcrumbs crumbs={[{ label: "Design" }]} />
                        <PageTitle>Pages</PageTitle>
                    </Section>
                    <NewPageButton />
                </Container>

                <WithApps>
                    {({ selectedApp }) => {
                        // <RecordTable filters={{ app_id: selectedApp._sid }} objectId={"pages"} />
                        //
                        const filters = selectedApp.id ? { app_id: selectedApp.id } : {}
                        return (
                            <WithPages>
                                {({ pages, onChange }) => (
                                    <PageTable onChange={onChange} data={pages} filters={filters} />
                                )}
                            </WithPages>
                        )
                    }}
                </WithApps>
            </Studio>
        )
    }
}



// WEBPACK FOOTER //
// ./src/features/studio/containers/PageListPage.js